import React from 'react'
import throttle from 'lodash.throttle'

import { useAgent } from '../AgentProvider'
import { useAuth } from '../AuthProvider'

const PING_INTERVAL = 1000 * 60 * 1 // Send ping every minute

const AwayStatusProvider = ({ children }) => {
  const { updatePresence } = useAgent()
  const { isLoading, isLoggedIn } = useAuth()

  // Handles listeners and sending updates
  React.useEffect(() => {
    if (!isLoggedIn || isLoading) {
      return
    }

    // Send updates
    const action = throttle(() => {
      updatePresence()
    }, PING_INTERVAL)

    // Register listeners
    const events = ['mousemove', 'mousedown', 'touchstart', 'click', 'keydown']
    events.forEach(ev => {
      window.addEventListener(ev, action, true)
    })

    return () => {
      // Stop pending updates
      action.cancel()

      // De-register listeners
      events.forEach(ev => {
        window.removeEventListener(ev, action, true)
      })
    }
  }, [isLoggedIn, isLoading, updatePresence])

  return children
}

export default AwayStatusProvider
